import { AlertDialog, HeaderProjectPreview } from '@centerpiece/components';
import { ProjectComponent, ProjectComponentProps } from 'components/Project';
import { ProjectPlan } from 'components/project/ProjectPlan';
import { ProjectProvider, ProjectContext } from 'contexts/project.context';
import React, { useRef, useState } from 'react';

export const ProjectPreviewTab = (project_props: ProjectComponentProps) => {
  const {
    id,
    template,
    disabled,
    afterSave,
    preview,
    // header,
    onBack,
    // onLogoClick,
    // exampleProject,
  } = project_props;

  const itemsRef = useRef({});
  return (
    <ProjectProvider
      id={id}
      template={template}
      disabled={disabled}
      afterSave={afterSave}
      itemsRef={itemsRef}
      preview={true}
    >
      <ProjectContext.Consumer>
        {({ project, alertDetails, setAlertDetails }) => (
          <div style={{ overflowY: 'scroll' }}>
            {template && (
              <HeaderProjectPreview
                title={`Template ${preview ? `Preview` : ``}: ${
                  project?.title || ''
                }`}
                onBack={onBack}
              />
            )}
            <ProjectPlan {...project_props} />
            <AlertDialog
              {...(alertDetails || {})}
              onClose={() => {
                setAlertDetails({ open: false });
              }}
            />
          </div>
        )}
      </ProjectContext.Consumer>
    </ProjectProvider>
  );
};
